export function isNameUnused(name: string, existingNames: Array<string>): boolean {
  return !existingNames.includes(name);
}
